import { useMutation, useQuery } from "@tanstack/react-query";
import accountSettingsService from "src/services/accountSettingsService";
import { FETCH_QUERY_KEYS } from "../consts";

export const useFetchAccountSettings = ({ accountId, enabled }) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.ACCOUNT_SETTINGS, accountId],
  queryFn: () => accountSettingsService.fetchAccount(accountId),
  enabled
});

export const useFetchAccountSftpSettings = ({ accountId, enabled }) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.ACCOUNT_SETTINGS_SFTP, accountId],
  queryFn: () => accountSettingsService.fetchSftpSettings(accountId),
  enabled,
  gcTime: 0
});

export const useEditAccountSettings = (options = {}) => useMutation({
  mutationFn: ({ accountId, data }) => accountSettingsService.editAccount(accountId, data),
  ...options
});

export const useFetchSubscription = ({ accountId, enabled }) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.SUBSCRIPTION, accountId],
  queryFn: () => accountSettingsService.fetchSubscription(accountId),
  enabled
});

export const useFetchSubscriptionUsageOverTime = ({ accountId, enabled }) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.SUBSCRIPTION_USAGE_OVER_TIME, accountId],
  queryFn: () => accountSettingsService.fetchSubscriptionUsageOverTime(accountId),
  enabled
});
